import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-allowed',
  templateUrl: './not-allowed.component.html'
})
export class NotAllowedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/nonanon/not-allowed.component.ts